import { Box, Button, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import AppSimpleDialog from 'app/shared-components/dialogs/AppSimpleDialog';
import { completeGetStarted } from 'src/app/api/MerchantApi';
import IQueryKeys from 'src/app/types/IQueryKeys';
import { ModalComponent } from './modalManager';

const PEPTIDES_MESSAGE =
  'Thank you for signing up! Because your industry has unique requirements, we provide specialized account handling. One of our experts will reach out soon to walk you through the next steps.';

export const MerchantPeptidesModal: ModalComponent = ({ open, onClose }) => {
  const queryClient = useQueryClient();

  const handleClose = async () => {
    try {
      await completeGetStarted();
      await queryClient.refetchQueries({ queryKey: [IQueryKeys.merchantInfoKey] });
    } catch (error) {
      console.error('Error completing get started:', error);
    }
    onClose();
  };

  return (
    <AppSimpleDialog
      open={open}
      handleClose={handleClose}
      onClose={handleClose}
      title="Thank you for signing up"
      size="md"
      scroll="paper"
      maxWidth="sm"
    >
      <Box sx={{ p: 3 }}>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {PEPTIDES_MESSAGE}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            onClick={handleClose}
            className="flex items-center text-15 text-white font-500 bg-blue-primary hover:bg-blue-primary-hover px-16 py-8"
          >
            OK
          </Button>
        </Box>
      </Box>
    </AppSimpleDialog>
  );
};
